import { Modal, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import deleteIcon from '../../../assets/images/delete-icon.svg';
import AlumlyButton from '../../../components/AlumlyButton';
import { RouteNameEnum } from '../../../enums/routeName';
import { ServiceNameEnum } from '../../../enums/serviceName';
import useServices from '../../../hooks/useServices';
import { AxiosService } from '../../../utils/axiosService';

interface Props { newsId: number; isOpen: boolean; handleClose: () => void; }

const DeleteNewsModal: React.FC<Props> = ({ isOpen, handleClose, newsId }) => {
  const navigate = useNavigate();
  const { service: deleteService } = useServices(ServiceNameEnum.news.delete);

  const deleteNews = async (): Promise<void> => {
    const { data, error } = await deleteService.delete({ params: { id: newsId } });
    if (data) { handleClose(); toast.success('News deleted successfully'); navigate(RouteNameEnum.news.index); }
    else if (error) { toast.error(AxiosService.getErrorResponse(error)?.message); }
  };

  return (
    <Modal open={isOpen} onCancel={handleClose} footer={null} centered styles={{ body: { textAlign: 'center' } }}>
      <div style={{ marginTop: 32 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={deleteIcon} alt="" style={{ width: '70px', height: '70px' }} />
        </div>
        <Typography.Title level={4} style={{ fontWeight: 'bold' }}>Are you sure you want to delete this news?</Typography.Title>
      </div>
      <div style={{
        display: 'flex', justifyContent: 'center', marginTop: 24, paddingTop: 16, paddingBottom: 24,
      }}
      >
        <AlumlyButton label="rxvWhite" width={180} onClick={handleClose}>Cancel</AlumlyButton>
        <div style={{ marginLeft: 16 }}><AlumlyButton label="rxv" width={180} onClick={deleteNews}>Delete</AlumlyButton></div>
      </div>
    </Modal>
  );
};

export default DeleteNewsModal;
